var uiCursorPagination = {
	caption: "Paginación del cursor",
	first: "Primera página",
	previous: "Página anterior",
	next: "Siguiente página"
};
var es = {
	uiCursorPagination: uiCursorPagination
};

export { es as default, uiCursorPagination };
